import React, { useState, useEffect} from "react";
import { Button, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import UpdateUserModal from "../UpdateUserModal";
import AccessRights from "utils/AccessRights";
import { gypsyballusersListFetch, usersListFetch} from "actions";
import DataTable from "CommonComponent/DataTable"; // Adjust import path

const UserList = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const data =
    useSelector((state) => state.usersRoleState.usersListFetch) || [];

  useEffect(() => {
    const object_viewed_id =session?.current_page_permissions?.object_id || '';

    dispatch(gypsyballusersListFetch());
    dispatch(usersListFetch(object_viewed_id));
  }, [dispatch]);

  const [modalShow, setModalShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState({
    user_id: "",
    userName: "",
    userEmail: "",
  });

  const columns = [
    {
      id: "name",
      header: "Name",
      accessor: (row) => row.name,
      sortable: true,
      searchable: true,
    },
    {
      id: "email",
      header: "Email",
      accessor: (row) => row.email,
      sortable: true,
      searchable: true,
    },
    {
      id: "roles",
      header: "Roles",
      accessor: (row) =>
        row.roles && row.roles.length > 0
          ? row.roles.map((role) => role.name).join(", ")
          : "",
      sortable: true,
      searchable: true,
    },
    {
      id: "action",
      header: "Action",
      accessor: null,
      cell: (_, row) =>
        AccessRights(
          session.current_page_permissions,
          "edit",
          row.created_by
        ) && row.is_deleted === "n" ? (
          <Button
            variant="none"
            className="border-0"
            onClick={() =>
              setSelectedUser({
                user_id: row.id,
                userName: row.name,
                userEmail: row.email,
              }) || setModalShow(true)
            }
          >
            <Image src="/assets/images/access.svg" />
          </Button>
        ) : (
          ""
        ),
      sortable: false,
      searchable: false,
    },
  ];

  return (
    <>
      <div>
        <DataTable
          columns={columns}
          data={data}
          serverSide={false}
          showSearch={true}
          className="object-list-table"
        />
      </div>
      <UpdateUserModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setSelectedUser({ user_id: "", userName: "", userEmail: "" });
        }}
        user_id={selectedUser.user_id}
        userName={selectedUser.userName}
        userEmail={selectedUser.userEmail}
      />
    </>
  );
};

export default UserList;
